import { useContext } from 'react';

import {
  type DotSeriesDataInternal,
  XYChartDotSeriesDataContext,
} from '../context/XYChartDotSeriesDataContext.js';

export const useDotSeriesData = () => {
  const context = useContext(XYChartDotSeriesDataContext);

  if (context === undefined) {
    throw new Error(
      'useDotSeriesData must be used within a XYChartDotSeriesDataContext',
    );
  }

  return context as Required<DotSeriesDataInternal>;
};
